module.exports = __webpack_public_path__ + "img/logo-nutrimix-distribuidora.d01de598.svg";